import { toUserMessage } from "utils/apiErrorHelper";
import { api } from "../../DefaultService";
import type { IPaginationParams, ISelectionOption } from "../../types";
import type { IRecognitionFilterParams } from "../types";
import type {
	IResponsibleRecognitionCreateProps,
	IResponsibleRecognitionProps,
	IResponsibleRecognitionSimpleProps,
	IResponsibleRecognitionUpdateParams,
} from "./types";

const ENDPOINT = "v1/recognitions/responsible";

const formatApiError = (error: any): Error => {
  return new Error(toUserMessage(error));
};

export const createResponsibleRecognitionAsync = async (
  data: IResponsibleRecognitionCreateProps,
): Promise<IResponsibleRecognitionProps> => {
  try {
    const res = await api.post(`${ENDPOINT}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 0,
    });
    return res.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const updateResponsibleRecognitionAsync = async ({
  id,
  data,
}: IResponsibleRecognitionUpdateParams): Promise<IResponsibleRecognitionProps> => {
  try {
    const response = await api.put(`${ENDPOINT}/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getResponsibleRecognitionByIdAsync = async (
	id: number,
): Promise<IResponsibleRecognitionProps> => {
	return await api
		.get(`${ENDPOINT}/${id}`)
		.then((response) => response.data)
		.catch((error) => {
			throw new Error(
				error?.response?.data?.userMessage || "Erro interno do servidor!",
			);
		});
};

export const getAllResponsibleByLicenseAsync = async (
	pagination?: IPaginationParams,
	filter?: IRecognitionFilterParams,
): Promise<IResponsibleRecognitionSimpleProps[]> => {
	return await api
		.get(`${ENDPOINT}/getAllByLicense`, {
			params: { ...pagination, ...filter },
		})
		.then((response) => response.data)
		.catch((error) => {
			throw new Error(
				error?.response?.data?.userMessage || "Erro interno do servidor!",
			);
		});
};

export const getAllResponsiblesForSelectionAsync = async (): Promise<
	ISelectionOption[]
> => {
	try {
		const response = await api.get(`${ENDPOINT}/selection`);
		return response.data;
	} catch {
		throw new Error("Erro ao buscar lista de responsáveis.");
	}
};
